import styled, { css, RuleSet } from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 100dvh;
`;

export const PageContent = styled.div<{ $background?: RuleSet<object> }>(
  ({ $background }) => css`
    ${$background};

    flex-grow: 1;
    overflow-x: clip;
  `,
);
